/**
 * Customer-facing control status labels for Overview (API may still return internal enums/labels).
 */

export const CONTROL_STATUS_DISPLAY_LABELS: Record<string, string> = {
  needs_review: 'Needs review',
  exposed: 'Control not verified',
  owner_assigned: 'Risk owner assigned',
  action_pending: 'Action pending',
  under_followup: 'Under follow-up',
  measurement_pending: 'Measurement pending',
  controlled: 'Controlled',
  not_actionable: 'Not actionable',
  suppressed: 'Suppressed',
  unknown: 'Unknown',
};

export const CONTROL_STATUS_DISPLAY_TOOLTIPS: Record<string, string> = {
  needs_review: 'Recurring safety risk without verified risk status.',
  exposed:
    'This recurring risk has evidence of exposure, but review, ownership, follow-up, or measurement is not complete enough to verify that the control is working.',
  owner_assigned:
    'A risk owner is assigned. Action owner or impact tracking may still be missing.',
  action_pending: 'Corrective action is pending on this recurring risk.',
  under_followup: 'Follow-up is active; control is not yet verified.',
  measurement_pending: 'Follow-up exists, but before/after measurement has not been recorded.',
  controlled: 'Only shown when measurement supports the control status.',
  not_actionable: 'Risk closed or classified as not requiring action.',
  suppressed: 'Similar occurrences are suppressed for a defined window.',
  unknown: 'Control status could not be determined from current data.',
};

export function displayControlStatusLabel(status: string, apiLabel?: string | null): string {
  const key = String(status || '')
    .trim()
    .toLowerCase();
  if (CONTROL_STATUS_DISPLAY_LABELS[key]) {
    return CONTROL_STATUS_DISPLAY_LABELS[key];
  }
  const fallback = String(apiLabel || '').trim();
  if (fallback.toLowerCase() === 'exposed') {
    return CONTROL_STATUS_DISPLAY_LABELS.exposed;
  }
  return fallback || CONTROL_STATUS_DISPLAY_LABELS.unknown;
}

export function displayControlStatusTooltip(status: string): string {
  const key = String(status || '')
    .trim()
    .toLowerCase();
  return CONTROL_STATUS_DISPLAY_TOOLTIPS[key] || CONTROL_STATUS_DISPLAY_TOOLTIPS.unknown;
}
